import React from "react";
import { Routes, Route } from "react-router-dom";
import { InvitationPage } from "../../../pages/invitationPage";
import { PublicLayout } from "../../layout/public/PublicLayout";
import { ReadingLayout } from "../../layout/public/session/ReadingLayout";
import { ParticipantDashboard } from "../../participant/Dashboard";
import { ParticipantOnlineSessionPage } from "../../../pages/ParticipantOnlineSessionPage";
import { ParticipantInPersonSessionPage } from "../../../pages/ParticipantInPersonSessionPage";
import { ReadStoryPage } from "../../../pages/ReadStoryPage";
import { ParticipantRoute } from "./ParticipantRoute";
import { ReadAtHomeSurvey } from "../../participant/ReadAtHomeSurvey";
import { SurveyClosePage } from "../../participant/surveyDialog/SurveyClosePage";

const ParticipantRoutes = (): React.ReactElement => {
    return (
        <>
            <Routes>
                <Route
                    path="/participant/survey/close"
                    element={<ParticipantRoute isPublic layout={PublicLayout} component={SurveyClosePage} />}
                />
                <Route
                    path="/invite/:jwt?"
                    element={<ParticipantRoute isPublic layout={PublicLayout} component={InvitationPage} />}
                />
                <Route
                    path="/invite"
                    element={<ParticipantRoute isPublic layout={PublicLayout} component={InvitationPage} />}
                />
                <Route
                    path="/sign-in/:jwt?"
                    element={
                        <ParticipantRoute
                            isPublic
                            layout={PublicLayout}
                            component={() => <InvitationPage isSignIn />}
                        />
                    }
                />
                <Route
                    path="/sign-in"
                    element={
                        <ParticipantRoute
                            isPublic
                            layout={PublicLayout}
                            component={() => <InvitationPage isSignIn />}
                        />
                    }
                />
                <Route
                    path="/participant/dashboard"
                    element={<ParticipantRoute layout={PublicLayout} component={ParticipantDashboard} />}
                />
                <Route
                    path="/participant/:participantId/online-session/:sessionId"
                    element={<ParticipantRoute layout={ReadingLayout} component={ParticipantOnlineSessionPage} />}
                />
                <Route
                    path="/participant/:participantId/session/:sessionId"
                    element={<ParticipantRoute layout={ReadingLayout} component={ParticipantInPersonSessionPage} />}
                />
                <Route
                    path="/read-story/:id/:sessionId?"
                    element={<ParticipantRoute layout={ReadingLayout} component={ReadStoryPage} />}
                />
                <Route
                    path="/read-story/:id"
                    element={<ParticipantRoute layout={ReadingLayout} component={ReadStoryPage} />}
                />
                <Route
                    path="/survey/:id"
                    element={<ParticipantRoute layout={ReadingLayout} component={ReadAtHomeSurvey} />}
                />
            </Routes>
        </>
    );
};

export default ParticipantRoutes;
